import { ExperiencePerformanceTypes } from '@atlassian/ufo-experimental';
export var isInitialPageLoad = function isInitialPageLoad(data) {
  return data.performanceType === ExperiencePerformanceTypes.PageLoad && data.initial === true;
};